// What the import form takes — the same files as the apps: iOS
// (supportedImportDocumentTypes + AudioFileTranscriber) and Android
// (ImportPickers.MIME_DOCS and its photo picker). No video, no archive:
// nothing the note generation reads.

const DOCUMENTS = ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "md", "rtf"];
const IMAGES = ["jpg", "jpeg", "png", "heic", "heif", "webp", "gif"];
// Recordings, transcribed in the page (utils/audioTranscriber.js).
export const AUDIO_EXTENSIONS = ["m4a", "mp3", "wav", "aiff", "aif", "aac", "flac", "caf"];

const IMPORT_EXTENSIONS = new Set([...DOCUMENTS, ...IMAGES, ...AUDIO_EXTENSIONS]);

/** For the file input's `accept`: extensions only — a MIME family like
 *  `audio/*` let the system picker offer videos too. */
export const IMPORT_ACCEPT = [...IMPORT_EXTENSIONS].map((ext) => `.${ext}`).join(",");

export function extensionOf(file) {
  const name = (file && file.name) || "";
  const dot = name.lastIndexOf(".");
  return dot < 0 ? "" : name.slice(dot + 1).toLowerCase();
}

export function isImportable(file) {
  return IMPORT_EXTENSIONS.has(extensionOf(file));
}
